
import React from 'react';
import { InfoTwoTone as DefaultInfoIcon, SvgIconComponent } from '@mui/icons-material';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { classes, StyledHtmlTooltip } from './TooltipValueViewer.styles';

export interface TooltipValueViewerProps {
  cell: ICell;
  icon?: SvgIconComponent;
}

const TooltipValueViewer = ({ cell, icon: Icon = DefaultInfoIcon }: TooltipValueViewerProps) => (
  <StyledHtmlTooltip title={cell.defaultTooltip ?? ''} placement="top" arrow>
    <span className="value-viewer">
      <span className="text-cell">{String(cell.value ?? '')}</span>
      <Icon className={classes.icon} />
    </span>
  </StyledHtmlTooltip>
);

export default TooltipValueViewer;
